export default __webpack_public_path__ + "static/media/swatch.d741e43b.mp4";